/*
  Sticky add-to-cart bar behavior.
  Extracted from an inline <script> in layout/theme.liquid so it loads deferred
  and cached. Scroll handling is now passive + rAF-throttled to avoid main-thread
  jank (better INP/TBT). Behavior is otherwise identical to the original.
*/
(function () {
  var stickyBar = document.getElementById('amuee-sticky-atc');
  var stickyBtn = document.getElementById('amuee-atc-btn');
  if (!stickyBar || !stickyBtn) return;

  var originalBtn = document.querySelector('form[action*=cart] button[type=submit]');
  if (!originalBtn) return;

  function checkScroll() {
    var btnPosition = originalBtn.getBoundingClientRect().bottom;
    if (btnPosition < 0) {
      stickyBar.classList.add('visible');
    } else {
      stickyBar.classList.remove('visible');
    }
  }

  // SCROLL CONFIGURATION - CHANGE THESE VALUES
  var scrollPaddingDesktop = 250; // Desktop: Space from top in pixels
  var scrollPaddingMobile = 70;   // Mobile: Space from top in pixels

  stickyBtn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var isMobile = window.innerWidth <= 749;
    var scrollPadding = isMobile ? scrollPaddingMobile : scrollPaddingDesktop;

    // Try multiple selectors for Rapi bundle section
    var selectors = [
      '#shopify-block-rapi_bundle_upsell',
      '.rapi-block.shopify-app-block',
      '.shopify-block[id*="rapi"]',
      '[id*="rapi-bundle"]'
    ];

    var targetElement = null;
    for (var i = 0; i < selectors.length; i++) {
      targetElement = document.querySelector(selectors[i]);
      if (targetElement) break;
    }

    if (targetElement) {
      var elementPosition = targetElement.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - scrollPadding;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, true); // Use capture phase

  // Passive + rAF-throttled scroll listener (was an unthrottled non-passive handler)
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        checkScroll();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  checkScroll();
})();
